<script setup>
import {HorizontalNavGroup, HorizontalNavLink} from '@layouts/components'
import {themeConfig} from "@themeConfig"
import NavbarThemeSwitcher from "@/layouts/components/NavbarThemeSwitcher.vue"
import NavBarNotifications from "@/layouts/components/NavBarNotifications.vue"
import UserProfile from "@/layouts/components/UserProfile.vue"
import {VNodeRenderer} from "@layouts/components/VNodeRenderer.jsx"

const props = defineProps({
  navItems: {
    type: null,
    required: true,
  },
})

const resolveNavItemComponent = item => {
  if ('children' in item)
    return HorizontalNavGroup

  return HorizontalNavLink
}
</script>

<template>
  <div class="d-flex align-center px-4">

    <!-- App logo and title -->

    <div class=" me-6" data-tauri-drag-region
         style="-webkit-app-region: drag;">
      <NuxtLink class="d-flex align-center app-logo-link" to="/">
        <VNodeRenderer :nodes="themeConfig.app.logo"/>
        <h1 class="font-weight-bold text-lg">
          {{ themeConfig.app.title }}
        </h1>
      </NuxtLink>
    </div>

    <!-- Left Spacer -->
    <div style="flex: 1;"></div>

    <!-- Centered nav items -->
    <ul class="d-flex align-center gap-x-1" style="flex: none;">
      <component
        :is="resolveNavItemComponent(item)"
        v-for="(item, index) in navItems"
        :key="index"
        :item="item"
        data-allow-mismatch
      />
    </ul>

    <!-- Right Spacer -->
    <div style="flex: 1;"></div>

    <!-- Right icons -->
    <div class="d-flex align-center gap-x-2">
      <NavbarThemeSwitcher/>
      <NavBarNotifications/>
      <UserProfile/>
    </div>

  </div>
</template>


<style lang="scss">
.layout-wrapper.layout-nav-type-horizontal {
  .nav-items {
    display: flex;
    flex-wrap: wrap;
  }

  .app-logo-link {
    gap: clamp(4px, calc(4px + (16 - 4) * ((100vw - 1378px) / (1920 - 1378))), 16px);
    margin-inline-end: clamp(4px, calc(4px + (12 - 4) * ((100vw - 1378px) / (1920 - 1378))), 12px);
  }
}
</style>
